import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import ChartCard, { TOOLTIP_STYLE } from "@/components/charts/ChartCard";

export default function PipelineChart({ data = [], className, testid = "pipeline-chart" }) {
  const chart = data.filter((d) => d.count > 0);
  return (
    <ChartCard title="Pipeline by stage" subtitle="Open deals across the sales pipeline" testid={testid} className={className}
      empty={chart.length === 0 ? "No open deals yet" : null}>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={chart} margin={{ top: 8, right: 8, left: -18, bottom: 40 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="stage" angle={-35} textAnchor="end" height={70} tick={{ fontSize: 11, fill: "#64748B" }} interval={0} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12, fill: "#64748B" }} />
          <Tooltip cursor={{ fill: "#F1F5F9" }} contentStyle={TOOLTIP_STYLE} />
          <Bar dataKey="count" name="Deals" fill="#0D9488" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
